import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PktrAppMenuService } from '@prospektr/pktr-app-menu';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ListingService } from 'src/app/_shared/service/listings.service';
import { ClientDashboardState } from 'src/app/client-dashboard/state/client-dashboard.state';
import { LoginFieldInputErrorCheck } from 'src/app/login/login.interface';
import { ValidatorsService } from 'src/app/shared/service/validators.service';

@Component({
  selector: 'app-add-expired-listings-notes-sheet',
  templateUrl: './add-expired-listings-notes-sheet.component.html',
  styleUrls: ['./add-expired-listings-notes-sheet.component.scss']
})
export class AddExpiredListingsNotesSheetComponent implements OnInit {

  openAddExpiredListingsNoteSheetValue: any = false;
  onDestroyNotifier$ = new Subject();
  adContactNoteForm: any;
  dialogRef: any;
  addContactSheetContext: any = false;
  patterns: LoginFieldInputErrorCheck;
  isLoading: boolean = false;
  isNameDisabled = false;
  address: any;
  showSecondClient = false;
  showSecondOwner = false;
  emailList = [];
  selectedEmails: string[] = [];
  disabledEmails: any;
  subscribedEmails = [];
  selectedEmailList: string[] = [];
  ListingsOwnerForm: any;



  constructor(
    private clientDashboardState: ClientDashboardState,
    private formBuilder: FormBuilder,
    private validators: ValidatorsService,
    private snackBar: MatSnackBar,
    private listingService: ListingService,
    public breakpointService: ValidatorsService,
    public _pktrAppMenuService: PktrAppMenuService,
  ) { }

  ngOnInit(): void {

    this.breakpointService
      .isMobileOrTablet()
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((isMobileOrTablet) => {
        if (isMobileOrTablet) {
          this._pktrAppMenuService.close(true);
        }

      });
    this.patterns = this.validators.patterns;
    this.ListingsOwnerForm = this.formBuilder.group({
      currentOwnerName: [''],
      currentOwnerEmail: ['', [Validators.email]],
      note: ['', [Validators.minLength(5)]],
    });

    this.clientDashboardState.openAddExpireListingsNoteSheet$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((status) => {
      this.openAddExpiredListingsNoteSheetValue = status;
    });

    this.clientDashboardState.expiredListingsSheetContext$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((context) => {
      this.addContactSheetContext = context?.data;
      this.ListingsOwnerForm.patchValue({
        note: this.addContactSheetContext?.notes
          ? this.addContactSheetContext.notes : '',
        currentOwnerName: this.addContactSheetContext?.OwnerName
          ? this.addContactSheetContext?.OwnerName : null,
        currentOwnerEmail: this.addContactSheetContext?.ownerEmail
          ? this.addContactSheetContext?.ownerEmail : null

      });
    });

  }

  getOwnerDetails() {
    const form = this.ListingsOwnerForm;

    const currentEmail = form.get('currentOwnerEmail');
    const note = form.get('note');
    const currentOwner = form.get('currentOwnerName');

    const payload: any = {};

    if (currentEmail?.dirty) {
      payload.ownerEmail = currentEmail.value;
    }

    if (note?.dirty) {
      payload.notes = note.value;
    }

    if (currentOwner?.dirty) {
      payload.ownerName = currentOwner.value;
    }
    return payload;
  }

  updateOwnerData() {
    if (!this.ListingsOwnerForm.valid) {
      return;
    }

    const payload = this.getOwnerDetails();
    payload.userId = this.addContactSheetContext?.userId || null;
    payload.ListingId = this.addContactSheetContext?.ListingId || null
    if (Object.keys(payload).length > 0 && payload.ownerName || payload.notes || payload.ownerEmail) {
      this.listingService.updateExpiredListingsOwnerData(payload)
        .subscribe((res: any) => {

          if (res?.data?.success) {
            this.openSnackBar('update successfully completed', 'snackbar-success');
            this.openAddExpiredListingsNoteSheetValue = false;
            this.clientDashboardState.triggerTableRefresh({
              pageIndex: this.addContactSheetContext?.currentPage,
              type: 'editEmail'
            });
            this.clientDashboardState.openAddexpireListingsNoteSheetValue = false;
          }


        }, err => {
          console.error(err);
        });

    } else {
      this.openSnackBar('please edit ownerEmail or ownerName', 'snackbar-error')

    }


  }



  closeAddContactSheet() {

    this.clientDashboardState.openAddexpireListingsNoteSheetValue = false;
  }

  openSnackBar(message, style) {
    if (message) {
      this.snackBar.open(message, '', {
        duration: 3000,
        panelClass: [style ? style : ''],
        verticalPosition: 'top',
      });
    }
  }
}
